import { routerReducer } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';
import { accessRequestReducer } from './access-requests';
import { controlPageReducer } from './control-page';
import { featureFlagsReducer } from './feature-flags';
import { invitationsReducer } from './invitation';
import { AppState } from './lemans-app.model';
import { signalrReducer } from './signalR';
import { trialsReducer } from './trials';
import { uiStateReducer } from './ui-state/store';
import { userAccessReducer } from './user-access';
import { setUserData } from './user-data';

export const reducers: ActionReducerMap<AppState> = {
  controlPage: controlPageReducer,
  signalR: signalrReducer,
  userData: setUserData,
  featureFlags: featureFlagsReducer,
  trials: trialsReducer,
  invitation: invitationsReducer,
  accessRequests: accessRequestReducer,
  routerState: routerReducer,
  uiState: uiStateReducer,
  userAccess: userAccessReducer,
};
